import { fixContent, drawBalance } from "../../utils";
import { not_available_vertical } from "../../pngs";
import { SingleProductImg } from "../CoalitionComplements";
import "./CoalitionCardExtras.scss";

export const CoalitionCardExtras = ({
  id,
  product,
  title,
  expiracy,
  extraPoints,
  showModal,
  buttonRef,
  fromPage = false,
}) => {
  const klass = fromPage ? "title add-space" : "title";
  return (
    <div
      className="card-extras"
      ref={buttonRef}
      onClick={() => showModal(id)}
      onKeyPress={() => showModal(id)}
      role="button"
      tabIndex={0}
    >
      <div className="bullet">
        {extraPoints ? `+ ${drawBalance(extraPoints)} puntos` : "Te da más"}
      </div>
      <div className="product">
        <SingleProductImg load={product} error={not_available_vertical} />
      </div>
      <div className={klass}>{fixContent(title, 30)}</div>
      {expiracy ? <div className="expiracy">Hasta el {expiracy}</div> : null}
    </div>
  );
};
